import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
} from "@ey-xd/motif-react";

import { SKU_APPROVE } from "../../../../pages/BMOSkuApproval/Constants";

import "./ApproveModal.scss";

export default function ApproveModal({
  show,
  setShow,
  approveHandler,
  payload,
}: {
  show: boolean;
  setShow: (isVisible: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave?: (updatedComment: any) => void;
  selectedSku?: string;
  approveHandler?: (mssg?: string, action?: string) => void;
  btnLabel: string;
  payload?: string;
}) {
  const approveSku = async () => {
    if (approveHandler && !payload) {
      approveHandler(SKU_APPROVE);
    }
    if (approveHandler && payload) {
      approveHandler(payload);
    } else {
      setShow(false);
    }
  };

  return (
    <MotifModal
      className="approve-order-modal"
      id="approveOrderModal"
      show={show}
      onClose={() => setShow(false)}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <>
        <MotifModalHeader>{"Alert"}</MotifModalHeader>
        <MotifModalBody>
          <div className="motif-col-lg-12  content">
            Are you sure you want to approve this SKU order?
          </div>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton variant={"primary"} onClick={() => setShow(false)}>
            Cancel
          </MotifButton>
          <MotifButton
            variant={"primary"}
            onClick={approveSku}
            className="approveButton"
          >
            Approve SKU
          </MotifButton>
        </MotifModalFooter>
      </>
    </MotifModal>
  );
}
